"use strict";

var _slicedToArray = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = exports.AccountAvatarType = void 0;

var _react = _interopRequireWildcard(require("react"));

var _emotionTheming = require("emotion-theming");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Link = _interopRequireDefault(require("../../Link"));

var _AccountAvatarMenu = _interopRequireDefault(require("../AccountAvatarMenu"));

var _AccountNotifications = _interopRequireDefault(require("../AccountNotifications"));

var _AccountAvatar = require("./AccountAvatar.style");

var AccountAvatarType = {
  Primary: 'primary',
  Mega: 'mega',
  Slider: 'slider'
};
exports.AccountAvatarType = AccountAvatarType;

var AccountAvatar = function AccountAvatar(_ref) {
  var avatar = _ref.avatar,
      avatarMenuLinks = _ref.avatarMenuLinks,
      avatarPrimaryLink = _ref.avatarPrimaryLink,
      avatarNotifications = _ref.avatarNotifications,
      variant = _ref.variant,
      isLargeNav = _ref.isLargeNav,
      variation = _ref.variation,
      rest = _objectWithoutProperties(_ref, ["avatar", "avatarMenuLinks", "avatarPrimaryLink", "avatarNotifications", "variant", "isLargeNav", "variation"]);

  var _ref2 = (0, _emotionTheming.useTheme)(),
      space = _ref2.space;

  var description = avatar.description,
      label = avatar.label;

  var _ref3 = (0, _react.useState)(false),
      _ref4 = _slicedToArray(_ref3, 2),
      isAvatarMenuOpen = _ref4[0],
      setIsAvatarMenuOpen = _ref4[1];

  var toggleAvatarMenu = function toggleAvatarMenu() {
    setIsAvatarMenuOpen(!isAvatarMenuOpen);
  };

  var dropdownRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var pageClickEvent = function pageClickEvent() {
      if (dropdownRef.current !== null) {
        setIsAvatarMenuOpen(!isAvatarMenuOpen);
      }
    };

    if (isAvatarMenuOpen) {
      window.addEventListener('click', pageClickEvent);
    }

    return function () {
      window.removeEventListener('click', pageClickEvent);
    };
  }, [isAvatarMenuOpen]);
  var hasNotifications = avatarNotifications && (!!avatarNotifications.url || !!avatarNotifications.counter); // When you haven't logged in, you pass a link to the login page

  if (avatarPrimaryLink && variant === AccountAvatarType.Slider) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, hasNotifications && /*#__PURE__*/_react.default.createElement(_AccountNotifications.default, Object.assign({
      avatarNotifications: avatarNotifications,
      variant: variant
    }, rest)), /*#__PURE__*/_react.default.createElement(_Link.default, Object.assign({
      to: avatarPrimaryLink
    }, rest), /*#__PURE__*/_react.default.createElement(_AccountAvatar.AvatarWrap, Object.assign({
      variant: variant
    }, rest), /*#__PURE__*/_react.default.createElement(_AccountAvatar.Avatar, null, label && /*#__PURE__*/_react.default.createElement("span", null, label)), description && variant === AccountAvatarType.Slider && /*#__PURE__*/_react.default.createElement(_AccountAvatar.Description, null, description), avatarPrimaryLink && variant === AccountAvatarType.Slider && /*#__PURE__*/_react.default.createElement(_AccountAvatar.Arrow, {
      name: "ChevronRight",
      size: space.base
    }))));
  } // When logged in


  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, hasNotifications && /*#__PURE__*/_react.default.createElement(_AccountNotifications.default, Object.assign({
    avatarNotifications: avatarNotifications,
    variant: variant
  }, rest)), /*#__PURE__*/_react.default.createElement(_AccountAvatar.AvatarWrap, Object.assign({
    variant: variant
  }, rest), /*#__PURE__*/_react.default.createElement(_AccountAvatar.Avatar, {
    onClick: toggleAvatarMenu
  }, label && /*#__PURE__*/_react.default.createElement("span", null, label)), description && variant === AccountAvatarType.Slider && /*#__PURE__*/_react.default.createElement(_AccountAvatar.Description, {
    variation: variation
  }, description), variant === AccountAvatarType.Slider && /*#__PURE__*/_react.default.createElement(_AccountAvatar.Arrow, {
    name: "ChevronRight",
    size: space.base
  }), avatarMenuLinks && isAvatarMenuOpen && /*#__PURE__*/_react.default.createElement(_AccountAvatarMenu.default, {
    avatarMenuLinks: avatarMenuLinks,
    toggled: isAvatarMenuOpen,
    dropdownRef: dropdownRef
  })));
};

AccountAvatar.propTypes = {
  avatar: _propTypes.default.shape({
    description: _propTypes.default.string,
    label: _propTypes.default.string
  }),
  avatarPrimaryLink: _propTypes.default.string,
  avatarNotifications: _propTypes.default.shape({
    url: _propTypes.default.string,
    counter: _propTypes.default.number
  }),
  avatarMenuLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string
  })),
  isLargeNav: _propTypes.default.bool,
  variant: _propTypes.default.oneOf(Object.values(AccountAvatarType)),
  variation: _propTypes.default.oneOf(['mega', 'primary'])
};
AccountAvatar.defaultProps = {
  avatar: null,
  avatarNotifications: null,
  avatarPrimaryLink: '/',
  avatarMenuLinks: [],
  isLargeNav: false,
  variant: AccountAvatarType.Primary,
  variation: 'mega'
};
var _default = AccountAvatar;
exports.default = _default;